// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3tOuK","footer":"ModalFilter_footer__1uUSn"};